import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];

/** @jsx jsx */
import { colors } from '@flowio/react-theme';
import { css, jsx } from '@emotion/react';
import { DialogTitle } from '@flowio/react-dialog';
import React from 'react';

var WorksheetTitle = function WorksheetTitle(_ref) {
  var children = _ref.children,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return jsx(DialogTitle, _extends({}, unhandledProps, {
    css: /*#__PURE__*/css({
      fontFamily: 'Roboto, sans-serif',
      fontSize: '22px',
      fontWeight: 300,
      fontStyle: 'normal',
      fontStretch: 'normal',
      lineHeight: '1.45',
      letterSpacing: 'normal',
      color: colors.GRAY_800
    }, process.env.NODE_ENV === "production" ? "" : ";label:WorksheetTitle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1dvcmtzaGVldFRpdGxlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFjUyIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Xb3Jrc2hlZXRUaXRsZS50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cblxuaW1wb3J0IHsgY29sb3JzIH0gZnJvbSAnQGZsb3dpby9yZWFjdC10aGVtZSc7XG5pbXBvcnQgeyBjc3MsIGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IERpYWxvZ1RpdGxlIH0gZnJvbSAnQGZsb3dpby9yZWFjdC1kaWFsb2cnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB0eXBlIHsgRGlhbG9nVGl0bGVQcm9wcyB9IGZyb20gJ0BmbG93aW8vcmVhY3QtZGlhbG9nJztcblxuY29uc3QgV29ya3NoZWV0VGl0bGU6IFJlYWN0LkZDPERpYWxvZ1RpdGxlUHJvcHM+ID0gKHtcbiAgY2hpbGRyZW4sXG4gIC4uLnVuaGFuZGxlZFByb3BzXG59KSA9PiAoXG4gIDxEaWFsb2dUaXRsZVxuICAgIHsuLi51bmhhbmRsZWRQcm9wc31cbiAgICBjc3M9e2Nzcyh7XG4gICAgICBmb250RmFtaWx5OiAnUm9ib3RvLCBzYW5zLXNlcmlmJyxcbiAgICAgIGZvbnRTaXplOiAnMjJweCcsXG4gICAgICBmb250V2VpZ2h0OiAzMDAsXG4gICAgICBmb250U3R5bGU6ICdub3JtYWwnLFxuICAgICAgZm9udFN0cmV0Y2g6ICdub3JtYWwnLFxuICAgICAgbGluZUhlaWdodDogJzEuNDUnLFxuICAgICAgbGV0dGVyU3BhY2luZzogJ25vcm1hbCcsXG4gICAgICBjb2xvcjogY29sb3JzLkdSQVlfODAwLFxuICAgIH0pfT5cbiAgICB7Y2hpbGRyZW59XG4gIDwvRGlhbG9nVGl0bGU+XG4pO1xuXG5Xb3Jrc2hlZXRUaXRsZS5kaXNwbGF5TmFtZSA9ICdXb3Jrc2hlZXRUaXRsZSc7XG5cbmV4cG9ydCBkZWZhdWx0IFdvcmtzaGVldFRpdGxlO1xuIl19 */")
  }), children);
};

WorksheetTitle.displayName = 'WorksheetTitle';
export default WorksheetTitle;